import React, { useState } from "react";

// Components
import JobDetail from "./JobDetail";

// Image
import TrackYourFirstJobImage from "../../../assets/image.png";

const JobsTable = ({
    jobs,
    user,
    getCategoryClass,
    maxVisibleJobs = 6,
    showBlurEffect = true,
    selectable = false,
    showStatus,
    selectedJobs = [],
    onJobSelect,
    onStatusChange,
}) => {
    const [jobStatuses, setJobStatuses] = useState(
        jobs.reduce(
            (acc, job) => ({ ...acc, [job.id]: job.status || "bookmarked" }),
            {}
        )
    );
    const [selectedJob, setSelectedJob] = useState(null);

    const handleStatusChange = (jobId, newStatus) => {
        setJobStatuses((prev) => ({
            ...prev,
            [jobId]: newStatus,
        }));
        if (onStatusChange) {
            onStatusChange(jobId, newStatus);
        }
    };

    const getStatusClass = (status) => {
        switch (status) {
            case "bookmarked":
                return "bg-gray-100 text-gray-800";
            case "applied":
                return "bg-blue-100 text-blue-800";
            case "interview":
                return "bg-purple-100 text-purple-800";
            case "offer":
                return "bg-green-100 text-green-800";
            case "no responses":
                return "bg-yellow-100 text-yellow-800";
            case "rejected":
                return "bg-red-100 text-red-800";
            default:
                return "bg-gray-100 text-gray-800";
        }
    };

    const displayedJobs = user ? jobs : jobs.slice(0, maxVisibleJobs);

    return (
        <>
            <table className="jobs-table">
                <thead>
                    <tr>
                        {selectable && <th></th>}
                        <th>Company</th>
                        <th>Location</th>
                        <th>Title</th>
                        <th>Type</th>
                        <th>Experience</th>
                        <th>Category</th>
                        <th>Status</th>
                    </tr>
                </thead>
                <tbody>
                    {displayedJobs.length === 0 && (
                        <tr>
                            <td colSpan="8" className="text-center">
                                <div className="flex flex-col items-center justify-center bg-white pt-8">
                                    <img
                                        src={TrackYourFirstJobImage}
                                        alt="Track Your First Job"
                                        className="w-72 h-56 mb-6"
                                    />

                                    <p className="text-md text-black text-center max-w-md">
                                        Browse our{" "}
                                        <a href="/" className="underline">
                                            job listings
                                        </a>{" "}
                                        and bookmark opportunities you've
                                        applied to or want to revisit later.
                                    </p>
                                </div>
                            </td>
                        </tr>
                    )}
                    {displayedJobs.map((job, index) => (
                        <tr
                            key={job.id}
                            className={`${
                                !user &&
                                index === maxVisibleJobs - 1 &&
                                showBlurEffect
                                    ? "relative blur-none"
                                    : ""
                            } cursor-pointer hover:bg-gray-50`}
                            onClick={() => setSelectedJob(job)}
                        >
                            {selectable && (
                                <td onClick={(e) => e.stopPropagation()}>
                                    <input
                                        type="checkbox"
                                        className="accent-black rounded-md w-4 h-4"
                                        checked={selectedJobs.includes(job.id)}
                                        onChange={() => onJobSelect(job.id)}
                                    />
                                </td>
                            )}
                            <td data-label="Company">{job.company}</td>
                            <td data-label="Location">{job.location}</td>
                            <td data-label="Title">{job.title}</td>
                            <td data-label="Type">{job.fulltime_parttime}</td>
                            <td data-label="Experience">{job.experience}</td>
                            <td data-label="Category">
                                <div
                                    className={`job-category-tag ${getCategoryClass(
                                        job.category
                                    )}`}
                                >
                                    {job.category}
                                </div>
                            </td>
                            {showStatus && (
                                <td
                                    data-label="Status"
                                    onClick={(e) => e.stopPropagation()}
                                >
                                    <select
                                        className={`status-dropdown rounded px-2 py-1 ${getStatusClass(
                                            jobStatuses[job.id]
                                        )}`}
                                        value={jobStatuses[job.id]}
                                        onChange={(e) =>
                                            handleStatusChange(
                                                job.id,
                                                e.target.value
                                            )
                                        }
                                    >
                                        <option value="bookmarked">Bookmarked</option>
                                        <option value="applied">Applied</option>
                                        <option value="interview">Interview</option>
                                        <option value="offer">Offer</option>
                                        <option value="no responses">
                                            No Responses
                                        </option>
                                        <option value="rejected">
                                            Rejected
                                        </option>
                                    </select>
                                </td>
                            )}

                            {!user &&
                                index === maxVisibleJobs - 1 &&
                                showBlurEffect && (
                                    <td className="absolute inset-0 bg-gradient-to-b from-transparent via-white/60 to-white/90 flex flex-col items-center justify-center z-10"></td>
                                )}
                        </tr>
                    ))}
                </tbody>
            </table>

            {selectedJob && (
                <JobDetail
                    job={selectedJob}
                    onStatusChange={handleStatusChange}
                    onClose={() => setSelectedJob(null)}
                />
            )}
        </>
    );
};

export default JobsTable;
